import React from 'react';
import type { ReactNode } from 'react';

interface ContentLayoutProps {
  leftSidebar: React.ReactNode;
  children?: ReactNode;
}

export function ContentLayout({ leftSidebar, children }: Readonly<ContentLayoutProps>) {
  return (
    <>
      <div className="min-w-[260px] w-[260px] pt-8 pl-8">{leftSidebar}</div>
      <div className="flex-1 mt-8 pr-8 w-full overflow-hidden">{children}</div>
    </>
  );
}
